import { AssciCode } from '@/common/constant'
import ExerciseStoreAPI from '@/apis/business/teacher/exercise-store-api.js'
import FileAPI from '@/apis/business/common/file-api.js'
import cloneDeep from 'lodash/cloneDeep'
import i18n from '@/i18n'
import Enumeration from '@/common/enumeration.js'
import {
  validateContentQuestion,
  validateContentAnswer,
  validateCorrectAnswer,
  validateMappingAnswer,
  handleMappingAnswer,
  handleBeforeSave
} from '@/views/pages/teacher/storage/create/common/common.js'
import { nextTick } from 'vue'

const NumberAnswerDefault = 4
const COEFFICIENT_DEFAULT = 1
const $t = i18n?.global?.t

export default {
  namespaced: true,

  state: {
    exerciseStore: {
      // Id: null,
      // Type: Enumeration.ExerciseType.Compose,
      // SubjectID: null,
      // SubjectCode: null,
      // SubjectName: null,
      // GradeID: null,
      // GradeName: null,
      // TopicIDs: [],
      // Title: null,
      // Tags: [],
      // Owner: null,
      // CoverImage: {},
      // QtyQuestion: 0,
      // Questions: [
      //   // {
      //   //   Type: Enumeration.QuestionType.Select,
      //   //   Content: null,
      //   //   Attachments: [],
      //   //   Owner: null,
      //   //   Hint: null,
      //   //   Answers: [],
      //   //   // MappingAnswer: {
      //   //   //   CorrectAnswer: null,
      //   //   //   AnswerColumnName: null
      //   //   // },
      //   //   ParentID: null,
      //   //   SortOrder: 0
      //   //   // NumberNo: null
      //   // }
      // ],
      // // ParentQuestions: [
      // //   // {
      // //   //   Content: null,
      // //   //   Attachments: [],
      // //   //   SortOrder: 0,
      // //   //   NumberNo: null,
      // //   //   IsSeamless: true
      // //   // }
      // // ],
      // QuestionAttachment: null,
      // AnswerAttachment: null,
      // AnswerType: Enumeration.AnswerType.Compose,
      // Status: null
    },
    exerciseStoreDefault: null,
    fileManager: [],
    questionPreviewIndex: 0,
    addQuestionType: 0,
    copyQuestionStatus: false,
    deleteQuestionStatus: false,

    questionIndex: 0,
    question: [null],
    allowDelete: true,
    addOnPreviewQuestion: null,
    summaryResults: null,
    isShowMask: false,
    errorQuestions: [],
    selectedQuestion: 0,
    isReadyComponent: true,
    currentParentID: null,
    currentQuestion: {
      Type: 0, // Loại câu hỏi
      Content: '', // Nội dung câu hỏi
      Attachments: [], // Đính kèm
      Owner: null, // Người sở hữu
      Hint: '', // Gọi ý
      Answers: [], // Danh sách câu trả lời
      SortOrder: null,
      Level: Enumeration.QuestionLevel?.Normal,
      Coefficient: COEFFICIENT_DEFAULT,
      NumberNo: null
    },
    NumberNo: null,
    ParentQuestion: [],
    composeDialogMode: Enumeration.EditMode.None,
    time: 0

  },

  getters: {
    newQuestion (state) {
      return {
        Type: 0, // Loại câu hỏi
        Content: '', // Nội dung câu hỏi
        Attachments: [], // Đính kèm
        Owner: null, // Người sở hữu
        Hint: '', // Gọi ý
        Answers: [], // Danh sách câu trả lời
        ParentQuestions: [],
        MappingAnswer: {
          CorrectAnswer: [],
          AnswerColumnName: [
            $t('Document.ColumnName', { columnName: 'A' }),
            $t('Document.ColumnName', { columnName: 'B' })
          ]
        },
        SortOrder: null,
        Level: Enumeration.QuestionLevel?.Normal,
        Coefficient: COEFFICIENT_DEFAULT,
        NumberNo: null
      }
    },

    newAnswer (state) {
      return {
        Correct: false, // Đúng|Sai
        Content: '', // Nội dung
        Image: null, // Ảnh đính kèm
        SortOrder: 0
      }
    },

    getExerciseStore (state) {
      return state.exerciseStore
    },

    questionFocus (state) {
      return state.questionPreviewIndex < state.exerciseStore?.Questions?.length ? state.exerciseStore?.Questions[state.questionPreviewIndex] : {}
    },

    /**
     * Tổng số câu hỏi
     * @param {*} state
     */
    totalQuestions (state) {
      return state.exerciseStore?.Questions?.length
    },

    /** Danh sách câu hỏi
     *  validate câu hỏi
     * @param {*} state
     * @returns
     */
    questions (state) {
      const questions = state.exerciseStore?.Questions?.map(question => {
        if (!question.ParentID) {
          if (validateCorrectAnswer(question) && validateContentAnswer(question) && validateContentQuestion(question) && validateMappingAnswer(question)) {
            question.isValid = true
          } else {
            question.isValid = false
          }
        } else {
          const parentQuestion = state.exerciseStore?.ParentQuestions?.find(parentQuestion => {
            return parentQuestion.SortOrder === question.ParentID
          })
          if (validateCorrectAnswer(question) && validateContentAnswer(question) && validateContentQuestion(parentQuestion)) {
            question.isValid = true
          } else {
            question.isValid = false
          }
        }
        return question
      })

      return questions || []
    },

    /**
     * Danh sách câu hỏi nhóm
     * @param {*} state
     * @returns
     */
    parentQuestionsFilter (state) {
      const questions = state.exerciseStore?.Questions
      let parentQuestions = []
      parentQuestions = questions?.map((question, index) => {
        return { question: question, index: index }
      })

      parentQuestions = parentQuestions?.filter(parentQuestion => {
        return !!parentQuestion.question.ParentID
      })

      let parentQuestionsFilter = []
      state.exerciseStore?.ParentQuestions?.forEach(parentQuestion => {
        let data = parentQuestions?.filter((element) => {
          return element.question.ParentID === parentQuestion.SortOrder
        })

        data = data?.map((item) => {
          return item.index
        })

        if (data.length > 1) parentQuestionsFilter?.push(data)
      })
      parentQuestionsFilter = parentQuestionsFilter?.sort((a, b) => {
        return a - b
      })

      // const parentID = questions[state.selectedQuestion - 1]?.ParentID
      // const data = questions.filter(question => {
      //   return question.ParentID === parentID
      // })

      return parentQuestionsFilter
    },

    /**
     * Chỉ số câu hỏi nhóm sựa vào câu hỏi đang focus
     * @param {*} state
     */
    parentQuestionsIndex (state) {
      const questions = state.exerciseStore?.Questions
      const parentID = questions[state.questionPreviewIndex]?.ParentID
      const dataIndexs = []

      questions.forEach((question, index) => {
        if (question.ParentID === parentID) dataIndexs.push(index)
      })

      return { startIndex: dataIndexs[0], endIndex: dataIndexs[dataIndexs.length - 1], dataIndexs: dataIndexs }
    },

    isHaveParentQuestion (state) {
      let result = false

      state.exerciseStore?.ParentQuestions.forEach(parentQuestion => {
        const questionIndex = state.exerciseStore?.Questions.findIndex(question => {
          return question.ParentID === parentQuestion.SortOrder
        })

        if (state.exerciseStore?.Questions[questionIndex + 1]?.ParentID) result = true
      })

      return result
    },

    ParentQuestionSortOrder (state) {
      const DEFAULT_VALUE = -1
      const parentQuestions = state.exerciseStore?.ParentQuestions

      const sortOrders = []
      if (parentQuestions?.length) {
        parentQuestions.forEach(parentQuestion => {
          sortOrders.push(parentQuestion.SortOrder)
        })

        sortOrders.sort((a, b) => {
          return a - b
        })
      }

      return sortOrders.length ? sortOrders[sortOrders.length - 1] + 1 : DEFAULT_VALUE
    }

  },

  mutations: {
    /**
     * set thời gian
     */
    setTime (state, param) {
      state.time = param
    },

    setCurrentParentID (state, parentID) {
      state.currentParentID = parentID
    },

    setCurrentQuestion (state, question) {
      state.currentQuestion = question
    },

    setComposeDialogMode (state, mode) {
      state.composeDialogMode = mode
    },

    /**
     * reset khi chọn cbb từ option câu hỏi nhóm sang câu hỏi loại khác
     * @author NTQuy
     * @param {*} state
     * @param {*} parentID
     */
    resetParentQuestions (state, parentID) {
      if (parentID) {
        const questions = state.exerciseStore.Questions
        const parentQuestionIndex = state.exerciseStore.ParentQuestions?.findIndex(parentQuestion => {
          return parentQuestion.SortOrder === parentID
        })
        const firstParentQuestion = questions?.findIndex(question => {
          return question.ParentID === parentID
        })

        const questionFilter = questions?.filter(question => {
          return question.ParentID !== parentID
        })

        if (firstParentQuestion > -1) {
          firstParentQuestion < state.questionPreviewIndex
            ? state.questionPreviewIndex = firstParentQuestion
            : state.questionPreviewIndex = firstParentQuestion - 1
        }
        state.exerciseStore.Questions = questionFilter
        state.exerciseStore.ParentQuestions?.splice(parentQuestionIndex, 1)
      }
    },

    /**
     * @description set tổng số câu đúng, sai, chưa làm
     * @param {} state
     * @param {*} params
     */
    setSummaryResults (state, param) {
      state.summaryResults = param
      // var questions = state?.exerciseStore?.Questions
      // state.summaryResults = {
      //   TotalCorrect: 0,
      //   TotalFalse: 0,
      //   TotalNotDone: 0
      // }

      // questions.map(item => {
      //   switch (item.Type) {
      //     case Enumeration.QuestionType.Yesorno:
      //       item.Answers.map((answer) => {
      //         var correct = item.CorrectAnswer.find(item => {
      //           return item.SortOrder === answer.SortOrder
      //         })
      //         if (correct && answer.Correct === true) { // học sinh trả lời
      //           if (correct.Correct === true) {
      //             // set màu xanh nếu câu trả lời đúng
      //             state.summaryResults.TotalCorrect += 1
      //           } else { // set màu đỏ nếu câu trả lời sai
      //             state.summaryResults.TotalFalse += 1
      //           }
      //         }
      //       })
      //       break
      //     case Enumeration.QuestionType.Select:
      //       var isCorrect = true
      //       var countAnswer = item.Answers.filter(x => x.Correct === true).length || 0
      //       if (countAnswer !== 0) {
      //         item.Answers.map((answer) => {
      //           var correct = item.CorrectAnswer.find(item => {
      //             return item.SortOrder === answer.SortOrder
      //           })
      //           if (correct && answer.Correct === true) { // giáo viên trả lời
      //             if (correct.Correct === false) {
      //             // set màu xanh nếu câu trả lời đúng
      //               isCorrect = false
      //               return false
      //             }
      //           }
      //         })
      //         if (isCorrect) {
      //           state.summaryResults.TotalCorrect += 1
      //         } else {
      //           state.summaryResults.TotalFalse += 1
      //         }
      //       }

      //       break
      //     case Enumeration.QuestionType.Fill:
      //       item.Answers.map(answer => {
      //         var correct = item.CorrectAnswer.find(item => { // lấy ra lời giải theo sort order
      //           return item.SortOrder === answer.SortOrder
      //         })
      //         if (correct) {
      //           const stringAnswer = answer?.Content?.toLowerCase()
      //           const listStringAnswer = correct?.Content?.toLocaleLowerCase()
      //           answer.numericalOrder = (String.fromCharCode(AssciCode.Upper[0] + answer.SortOrder)).toLowerCase() + '. '
      //           if (listStringAnswer?.includes(stringAnswer)) { // câu trả lời đúng
      //             state.summaryResults.TotalCorrect += 1
      //           } else { // câu trả lời sai
      //             state.summaryResults.TotalFalse += 1
      //           }
      //         }
      //       })
      //       break
      //     default:
      //       break
      //   }
      // })

      // state.summaryResults.TotalNotDone = questions.length - state.summaryResults.TotalCorrect - state.summaryResults.TotalFalse
    },

    /**
     * giữ nguyên trạng thái file soạn bài
     * @param {*} state
     * @param {*} exerciseStoreDefault
     */
    setExerciseStoreDefault (state, exerciseStoreDefault) {
      state.exerciseStoreDefault = exerciseStoreDefault
    },

    setExerciseStoreEdit (state, exerciseStore) {
      state.exerciseStore = null
      state.exerciseStore = state.exerciseStoreDefault

      if (exerciseStore) {
        state.exerciseStore = exerciseStore
      }
    },

    /**
     * Thay đổi state kiểm tra component có sẵn sàng để thực hiện các tác vụ hay không
     * @param {*} state
     * @param {*} isReady
     */
    setIsReadyComponent (state, isReady) {
      state.isReadyComponent = isReady
    },

    /**
     * setup dữ liệu để làm thử bài
     * @param {*} state
     * @param {*} exerciseStore
     */
    setExerciseStoreForTry (state, exerciseStore) {
      var lstCorrectAnswer = []

      state.exerciseStoreDefault = JSON.parse(JSON.stringify(exerciseStore || {}))

        // clone lstCorrectAnswer = correct
        exerciseStore?.Questions?.map((question, index) => {
          lstCorrectAnswer.push(question.Answers)
        })

        // clone Correct = CorrectAnswer
        state?.exerciseStoreDefault?.Questions.map((question, index) => {
          question.SortOrder = index + 1
          question.CorrectAnswer = null
          question.CorrectAnswer = JSON.parse(JSON.stringify(lstCorrectAnswer[index]))
        })

        // clear correct + content nếu là dạng fill
        state?.exerciseStoreDefault?.Questions.map(question => {
          question.Answers.map(answer => {
            answer.Correct = false
            if (question.Type === Enumeration.QuestionType.Fill) {
              answer.Content = ''
            }
          })
        })
    },

    /**
     * @author PVThang
     * @param {*} state
     * @param {object} newExerciseStore
     * @description set giá trị exerciseStore
     */
    setExerciseStore (state, newExerciseStore) {
      state.exerciseStore = newExerciseStore
    },

    /**
     * @description hàm set dữ liệu khi bấm vào sửa nhanh
     * @param {*} state
     * @param {*} question
     */
    setQuestionIndex (state, questionIndex) {
      state.questionIndex = questionIndex
    },

    /**
     * @description hàm set dữ liệu khi bấm vào sửa nhanh
     * @param {*} state
     * @param {*} question
     */
    setQuestion (state, question) {
      state.question = JSON.parse(JSON.stringify(question))
    },

    /**
     * @description kích hoạt trạng thái thêm câu hỏi
     * @author NTQuy
     * @param {*} state
     */
    addQuestion (state, param) {
      if (param.index !== null) {
        state.questionPreviewIndex = param.index
      }
      state.addQuestionType = param.addQuestionType
      nextTick(() => {
        param.callBack()
      })
    },

    /**
     * @description kích hoạt trạng thái copy câu hỏi
     * @author NTQuy
     * @param {*} state
     */
    copyQuestionStatus (state) {
      state.copyQuestionStatus = !state.copyQuestionStatus
    },

    /**
     * @description kích hoạt trạng thái xóa câu hỏi
     * @author NTQuy
     * @param {*} state
     */
    deleteQuestionStatus (state) {
      state.deleteQuestionStatus = !state.deleteQuestionStatus
    },

    /**
     * @author PVThang
     * @param {*} state
     * @param {*} questionType loại câu hỏi
     * @description thêm câu hỏi vào exerciseStore
     * @returns question được thêm
     */
    addAnswers (state, questionType) {
      const questionTypes = Enumeration?.QuestionTypeconst
      const answers = [] // Danh sách câu trả lời

      const answer = {
        Correct: false, // Đúng|Sai
        Content: '', // Nội dung
        Image: null, // Ảnh đính kèm
        SortOrder: 0
      }

      switch (questionType) {
        case questionTypes?.Yesorno:
          answers.push({ ...answer, Correct: true, Content: 'Đúng' })
          answers.push({ ...answer, Content: 'Sai' })
          break
        case questionTypes?.Group:
          //
          break
        case questionTypes?.Select:
          answers.push({ ...answer, Correct: true, Content: 'A' })
          answers.push({ ...answer, Content: 'B' })
          answers.push({ ...answer, Content: 'C' })
          answers.push({ ...answer, Content: 'D' })
          break
        case questionTypes?.Fill:
          answers.push({ ...answer })
          break
        case questionTypes?.Essay:
          answers.push({ ...answer })
          break
      }

      return answers
    },
    // theem 1 ds câu hỏi từ thư viện
    addListQuestion (state, questions) {
      const groupQuestions = questions.filter((question, index) => {
        question.Index = index
        return question.Type === Enumeration.QuestionType.Group
      })

      const exerciseParentQuestionIDs = state.exerciseStore.ParentQuestions?.map(parentQuestion => parentQuestion.SortOrder)
      let sortOrder = 0
      if (exerciseParentQuestionIDs?.length) {
        sortOrder = Math.max(...exerciseParentQuestionIDs)
      }

      const parentQuestions = []
      groupQuestions.reverse()?.forEach(groupQuestion => {
        let childrenQuestions = []

        sortOrder++
        childrenQuestions = groupQuestion.ChildrenQuestions?.map(question => {
          question.ParentID = sortOrder
          return question
        })

        questions.splice(groupQuestion.Index, 1)
        questions.splice(groupQuestion.Index, 0, ...childrenQuestions)
        groupQuestion.ParentQuestion.SortOrder = sortOrder
        parentQuestions.push(groupQuestion.ParentQuestion)
      })

      state.exerciseStore.ParentQuestions
        ? state.exerciseStore.ParentQuestions?.push(...parentQuestions.reverse())
        : state.exerciseStore.ParentQuestions = [...parentQuestions.reverse()]

      state.exerciseStore.Questions?.push(...questions)
      // state.exerciseStore.Questions.push(...questions)
    },

    /**
     * @author PVThang
     * @param {*} state
     * @param {*} index index của 1 question trong exerciseStore
     */
    setQuestionPreviewIndex (state, index) {
      if (state.exerciseStore?.Questions?.length > index && index >= 0) {
        state.questionPreviewIndex = index
      }
    },

    /**
     * @description Thay đổi câu hỏi preview khi dùng shortcut
     * @author NTQuy
     * @param {*} state
     * @param {*} index
     */
    keyupSetPreviewQuestion (state, index) {
      const firstPostionPreviewQuestion = document.getElementsByClassName('questionPreview')[0].getBoundingClientRect().y
      if (state.exerciseStore?.Questions?.length > index) {
        state.questionPreviewIndex = index
      }
      nextTick(() => {
        const lastPostionPreviewQuestion = document.getElementsByClassName('questionPreview')[0].getBoundingClientRect().y
        const rangeChangeQuestionPreview = lastPostionPreviewQuestion - firstPostionPreviewQuestion
        const questionsEl = document.getElementById('questions')

        if (lastPostionPreviewQuestion < document.getElementsByClassName('question')[0].offsetHeight || lastPostionPreviewQuestion > questionsEl.offsetHeight) {
          questionsEl.scrollTop += rangeChangeQuestionPreview
        }
      })
    },

    /**
     * @author PVThang
     * @param {*} state
     * @param {*} index index của câu hỏi bị xóa
     * @description Xóa câu hỏi trong exerciseStore
     */
    deleteQuestion (state, param) {
      const questions = state.exerciseStore?.Questions

      const numberQuestion = questions?.length
      const question = questions[param.index]
      let questionsFilter = []

      if (numberQuestion > 1 && param.index < numberQuestion) {
        if (question.ParentID && param.isRemoveParentQuestions) {
          const parentQuestions = state.exerciseStore?.ParentQuestions
          const firstParentQuestionIndex = questions?.findIndex(element => {
            return element.ParentID === question.ParentID
          })
          questionsFilter = questions?.filter(element => {
            return element.ParentID !== question.ParentID
          })
          const parentQuestionIndex = parentQuestions?.findIndex(parentQuestion => {
            return parentQuestion.SortOrder === question.ParentID
          })

          firstParentQuestionIndex
            ? state.questionPreviewIndex = firstParentQuestionIndex - 1
            : state.questionPreviewIndex = firstParentQuestionIndex
          parentQuestions?.splice(parentQuestionIndex, 1)

          state.exerciseStore.Questions = questionsFilter
        } else {
          state.exerciseStore.Questions.splice(param.index, 1)

          param.index === numberQuestion - 1 ? state.questionPreviewIndex = param.index - 1 : state.questionPreviewIndex = param.index
        }

        if (question.ParentID) {
          const childrenQuestionFilter = state.exerciseStore?.Questions?.filter(element => element.ParentID === question.ParentID)

          if (!childrenQuestionFilter.length) {
            const parentQuestionIndex = state.exerciseStore?.ParentQuestions?.findIndex(parentQuestion => parentQuestion.SortOrder === question.ParentID)

            state.exerciseStore?.ParentQuestions?.splice(parentQuestionIndex, 1)
          }
        }
        // if (index >= numberQuestion) {
        //   state.questionPreviewIndex = numberQuestion - 1
        // }
      } else {
        state.allowDelete = !state.allowDelete
      }
    },

    /**
     * @author PVThang
     * @param {*} state
     * @param {*} question Câu hỏi được copy
     * @description copy 1 câu hỏi vào vị trí của questionPreview
     */
    copyQuestion (state, param) {
      if (state.exerciseStore?.Questions) {
        state.exerciseStore.Questions.splice(state.questionPreviewIndex + 1, 0, {
          ...param.newQuestion,
          Level: Enumeration.QuestionLevel?.Normal,
          Coefficient: COEFFICIENT_DEFAULT
        })
        state.questionPreviewIndex++
      }
      nextTick(() => {
        param.callBack()
      })
    },

    /**
     * @author NTQuy
     * @description add data đọc từ file tải lên vào exercise store
     * @param {*} state
     * @param {*} questions
     */
    addQuestionsFromFileUpload (state, questions) {
      state.exerciseStore.Questions = questions
    },

    /**
     * Set giá trị mặc định cho addQuestionType
     * @param {*} state
     */
    setDefaultAddQuestionType (state) {
      state.addQuestionType = 0
    },

    /**
     * Thực hiện show mask
     * @param {*} state
     * @param {*} status
     */
    showMaskOnContainer (state, status) {
      state.isShowMask = status
    },

    /**
     * @description set trạng thái của các câu hỏi đang sai định dạng
     * @param {*} state
     * @param {*} errorQuestions
     */
    setErrorQuestions (state, errorQuestions) {
      state.errorQuestions = errorQuestions
    },

    /**
     * @description Đổi chỗ câu hỏi khi kéo thả đổi chỗ câu
     * @author NTQuy
     * @param {*} state
     * @param {*} params
     */
    swapQuestion (state, params) {
      const DRAG_INDEX = params.oldIndex
      const DROP_INDEX = params.newIndex
      const questions = cloneDeep(state.exerciseStore?.Questions)

      // const temp = questions[params.oldIndex]
      const questionDrag = questions[DRAG_INDEX]
      const questionDrop = questions[DROP_INDEX]

      if (!(questionDrag.ParentID && !questionDrop.ParentID)) {
        state.questionPreviewIndex = DROP_INDEX
      }

      if (!questionDrag.ParentID && !questionDrop.ParentID) {
        questions.splice(DRAG_INDEX, 1)
        questions.splice(DROP_INDEX, 0, questionDrag)
        state.exerciseStore.Questions = questions
        return
      }

      // kéo thả câu hỏi con trong cùng 1 nhóm
      if (questionDrag.ParentID && questionDrop.ParentID) {
        const childrenQuestionIndexs = []

        questions.forEach((question, index) => {
          if (question.ParentID === questionDrag.ParentID) {
            childrenQuestionIndexs.push(index)
          }
        })

        if (childrenQuestionIndexs.includes(DROP_INDEX)) {
          state.exerciseStore?.Questions?.splice(DRAG_INDEX, 1)
          state.exerciseStore?.Questions?.splice(DROP_INDEX, 0, questionDrag)
        }

        return
      }

      /// Kéo lên
      if (DRAG_INDEX > DROP_INDEX) {
        // Kéo 1 câu hỏi bình thường vào vùng câu hỏi nhóm
        if (!questionDrag.ParentID && questionDrop.ParentID) {
          const fisrChildrenIndex = questions.findIndex(question => {
            return question.ParentID === questionDrop.ParentID
          })

          state.exerciseStore?.Questions?.splice(DRAG_INDEX, 1)
          state.exerciseStore?.Questions?.splice(fisrChildrenIndex, 0, questionDrag)

          return
        }
      }

      // Kéo xuống
      if (DRAG_INDEX < DROP_INDEX) {
        // Kéo 1 câu hỏi bình thường vào vùng câu hỏi nhóm
        if (!questionDrag.ParentID && questionDrop.ParentID) {
          let lastChildrenIndex = -1

          questions.every((question, index) => {
            if (questions[index].ParentID && questions[index - 1]) {
              if (questions[index].ParentID === questionDrop.ParentID && (!questions[index + 1]?.ParentID || questions[index + 1].ParentID !== questionDrop.ParentID)) {
                lastChildrenIndex = index
                return false
              }
            }
            return true
          })

          state.exerciseStore?.Questions?.splice(lastChildrenIndex + 1, 0, questionDrag)
          state.exerciseStore?.Questions?.splice(DRAG_INDEX, 1)
        }
      }

      // state.questionPreviewIndex = params.newIndex
    },

    /**
     * @description set giá trị cho câu hỏi đang được select
     * @author NTQuy
     * @param {*} state
     * @param {*} index
     */
    setSelectedQuestion (state, index) {
      const totalQuestion = state.exerciseStore?.Questions?.length

      if (index && index <= totalQuestion) {
        state.selectedQuestion = index
      }
    },

    setFileManager (state, fileManager) {
      state.fileManager = fileManager
    }

  },

  actions: {
    /**
     * @author PVThang
     * @param {*} context
     * @returns 1 object câu hỏi mặc đinh
     */
    createNewQuestion (context, autoFillContent = false) {
      const question = {
        Type: 0, // Loại câu hỏi
        Content: '', // Nội dung câu hỏi
        Attachments: [], // Đính kèm
        Owner: null, // Người sở hữu
        Hint: '', // Gọi ý
        Answers: [], // Danh sách câu trả lời
        SortOrder: 0,
        MappingAnswer: {
          CorrectAnswer: [],
          AnswerColumnName: [
            $t('Document.ColumnName', { columnName: 'A' }),
            $t('Document.ColumnName', { columnName: 'B' })
          ]
        },
        Level: Enumeration.QuestionLevel?.Normal,
        Coefficient: COEFFICIENT_DEFAULT
      }
      const answer = {
        Correct: false, // Đúng|Sai
        Content: '', // Nội dung
        Image: null, // Ảnh đính kèm
        SortOrder: 0
      }

      for (let i = 0; i < NumberAnswerDefault; ++i) {
        const newAnswer = { ...answer }

        if (autoFillContent) {
          newAnswer.Content = String.fromCharCode(AssciCode.Upper[0] + i)
        }
        question.Answers.push(newAnswer)
      }

      return question
    },

    /**
     * @author PVThang
     * @param {*} context
     * @description Tạo 1 câu đáp án mới
     */
    createNewAnswer (context) {
      return {
        Correct: false, // Đúng|Sai
        Content: '', // Nội dung
        Image: null, // Ảnh đính kèm
        SortOrder: 0
      }
    },

    /**
     * @author PVThang
     * @param {*} context
     * @param {*} exerciseStore
     * @description Thêm học liệu
     */
    async insertExerciseStore (context, exerciseStore) {
      return await ExerciseStoreAPI.postAsync('', exerciseStore)
    },

    /**
     * @author PVThang
     * @param {*} context
     * @param {*} exerciseStore
     * @description update ExrciseStore
     */
    async updateExerciseStore (context, exerciseStore) {
      return await ExerciseStoreAPI.updateExerciseStore(exerciseStore?.Id, exerciseStore)
    },

    /**
     * @author PVThang
     * @param {*} context
     * @param {*} exerciseStore
     * @returns
     * @description thêm mới hoặc sửa
     */
    async upsertExercise (context, exerciseStore) {
      exerciseStore.Questions = exerciseStore.Questions?.map((question) => {
        delete question.CreatedDate
        delete question.ModifiedDate
        question.Answers = question.Answers?.map(answer => {
          delete answer.CreatedDate

          delete answer.ModifiedDate

          return answer
        })
        return question
      })
      const exerciseFormat = handleBeforeSave(exerciseStore)

      return await ExerciseStoreAPI.postAsync('upsert', exerciseFormat)
    },

    /**
     * @author PVThang
     * @param {*} context
     * @param {*} id
     * @description Lấy exerciseStore theo ID
     */
    getExerciseStore (context, id) {
      return new Promise((resolve, reject) => {
        ExerciseStoreAPI.getAsync(`${id}`).then(res => {
          if (res?.IsSuccess) {
            const exerciseStore = res.Data
            const exerciseStoreHandle = handleMappingAnswer(exerciseStore, Enumeration.HandlePairingAnswerType.Revert)

            context.commit('setExerciseStore', exerciseStoreHandle || {})
            resolve(true)
          } else {
            reject(res)
          }
        }
        ).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * @author PVThang
     * @description extract file
     * @param {*} context
     * @param {*} param
     * @returns
     */
    async extractFile (context, param) {
      return await FileAPI.postAsync('scanner/extraction', param)
    },

    /**
     * @author PVThang
     * @description extract file thành ảnh
     * @param {*} context
     * @param {*} param
     * @returns
     */
    async extractFileToImage (context, param) {
      return await FileAPI.postAsync('scanner/extraction-image', param)
    }

  }
}
